type Address = {
  id: number;
  emailAddress: string;
  type: string;
  isPrimary: boolean | null;
  isActive: boolean | null;
  isArchived?: boolean | null;
  status: string;
  companyId?: number | null;
};

export function contactPreferredAddress(contact: { email?: string | null; companyEmail?: string | null; privateEmail?: string | null }): string | null {
  return contact.email !== undefined ? contact.email : contact.companyEmail || contact.privateEmail || null;
}

/** Preference, classification and ownership are independent. A historical
 * address remains owned, but is never a destination for a new conversation. */
export function selectContactEmailAddresses<T extends Address>(rows: T[], currentCompanyId?: number | null) {
  const current = rows.filter(row => row.isActive && !row.isArchived && row.status === 'active' && row.type !== 'previous_work')
    .sort((a, b) => Number(Boolean(b.isPrimary)) - Number(Boolean(a.isPrimary)) || a.id - b.id);
  return {
    preferred: current[0]?.emailAddress ?? null,
    company: (current.find(row => row.type === 'work' && row.isPrimary)
      ?? (currentCompanyId == null ? undefined : current.find(row => row.type === 'work' && row.companyId === currentCompanyId))
      ?? current.find(row => row.type === 'work'))?.emailAddress ?? null,
    personal: current.find(row => row.type === 'personal')?.emailAddress ?? null,
  };
}
